export default class TextAusrichtung {
  static LINKSBUENDIG = 'linksbuendig';

  static BLOCKSATZ = 'blocksatz';

  static isValidState(ausrichtung) {
    return this.isLinksbuendig(ausrichtung) || this.isBlocksatz(ausrichtung);
  }

  static isLinksbuendig(ausrichtung) {
    return ausrichtung === this.LINKSBUENDIG;
  }

  static isBlocksatz(ausrichtung) {
    return ausrichtung === this.BLOCKSATZ;
  }
}
